import "./StatusBadge.css";

export type OrderStatus =
  | "pending"
  | "sent"
  | "completed"
  | "failed"
  | "awaiting_acknowledgement"
  | "acknowledged"
  | "order_completed"
  | "cancelled";

type StatusBadgeProps = {
  status: OrderStatus;
  isBackorder?: boolean;
};

const STATUS_CONFIG: Record<OrderStatus, { label: string; className: string }> =
  {
    pending: { label: "Afventer", className: "StatusBadge--pending" },
    sent: { label: "Sendt", className: "StatusBadge--sent" },
    completed: { label: "Gennemført", className: "StatusBadge--completed" },
    failed: { label: "Fejlet", className: "StatusBadge--failed" },
    awaiting_acknowledgement: { label: "Afventer bekræftelse", className: "StatusBadge--awaiting" },
    acknowledged: { label: "Bekræftet", className: "StatusBadge--acknowledged" },
    order_completed: { label: "Leveret", className: "StatusBadge--order-completed" },
    cancelled: { label: "Annulleret", className: "StatusBadge--cancelled" },
  };

export const StatusBadge = ({ status, isBackorder }: StatusBadgeProps) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;

  return (
    <span className="StatusBadge__wrapper">
      <span className={`StatusBadge ${config.className}`}>{config.label}</span>
      {isBackorder && (
        <span className="StatusBadge StatusBadge--backorder">Restordre</span>
      )}
    </span>
  );
};
